import { motion } from 'framer-motion';
import styled, { css, keyframes } from 'styled-components';

import { CollectionChainType } from '@app/client';

const maskWipe = keyframes`
  from {
    mask-position: 0 0%;
  }
  to {
    mask-position: 0 100%;
  }
`;

export const Wrapper = styled(motion.div)<{ $chain: CollectionChainType }>`
    position: absolute;
    inset: 0;
    border-radius: 10px;
    z-index: 1;

    padding: 24px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    mask-image: linear-gradient(to top, #fff 47%, transparent 53%);
    mask-size: 100% 220%;
    mask-position: 0 0;
    animation: ${maskWipe} 1s ease-in-out forwards;

    pointer-events: none;

    ${({ $chain }) => {
        switch ($chain) {
            case CollectionChainType.Polygon:
                return css`
                    background: linear-gradient(135deg, #9431d0 0%, #7b3fe4 100%);
                    box-shadow: 0 3.8877034187316895px 3.8877034187316895px 0 rgba(0, 0, 0, 0.25);
                `;
            case CollectionChainType.Aptos:
                return css`
                    background: linear-gradient(135deg, #1e545e 0%, #365d42 44.27%, #0c2635 100%);
                    box-shadow: 0 3.8877034187316895px 3.8877034187316895px 0 rgba(0, 0, 0, 0.25);
                `;
        }
    }}
`;

export const Text = styled.div`
    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: -0.48px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;

export const Icon = styled.div`
    svg {
        width: 100%;
        max-width: 190px;
    }
`;
